import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { useOutsideAlerter } from 'utils/customHook/useOutsideAlerter';

import Popup from 'popup/Popup';
import ModuleIcon from './icon/ModuleIcon';

import ModuleStatusPopup from './popup/ModuleStatusPopup';
import MainMapInfoPopup from './popup/MainMapInfoPopup';

const ModuleInMap = (props) => {
  const cancellationToken = useCancellationToken();
  const confirmIdxs = useSelector((state) => state.warningAlert.confirm);
  const [statusPopupOn, setStatusPopupOn] = useState(false);
  const [alertAnimationOn, setAlertAnimationOn] = useState(false);

  const wrapperRef = useRef(null);
  const popupOutsiderClickCheck = useOutsideAlerter(wrapperRef);

  useEffect(() => {
    if (!popupOutsiderClickCheck) {
      setStatusPopupOn(popupOutsiderClickCheck);
    }
  }, [popupOutsiderClickCheck]);

  useEffect(() => () => cancellationToken.cancel(), [cancellationToken]);

  const handleIconRightClick = (e) => {
    setStatusPopupOn((statusPopupOn) => {
      return !statusPopupOn;
    });

    e.preventDefault();
  };

  return (
    <div ref={wrapperRef} onContextMenu={handleIconRightClick}>
      <Popup
        trigger={
          <div>
            <ModuleIcon
              {...props}
              alertAnimationOn={alertAnimationOn}
              setAlertAnimationOn={setAlertAnimationOn}
              alertConfirm={!confirmIdxs.includes(props.moduleIdx)}
            />
          </div>
        }
        modal
        closeOnDocumentClick
        onOpen={() => {
          setAlertAnimationOn(false);
          props.audio.pause();
        }}
      >
        <MainMapInfoPopup {...props} />
      </Popup>
      {statusPopupOn && (
        <ModuleStatusPopup
          xcoordinate={props.xaxis}
          ycoordinate={props.yaxis}
          setStatusPopupOn={setStatusPopupOn}
          status={props.moduleStatus}
          moduleIdx={props.moduleIdx}
        />
      )}
    </div>
  );
};

export default ModuleInMap;
